import request from '@/util/request'


export const trainUsersDetail = (data) => request.post('/api/trainUsersDetail', data);  //我的任务

export const ApplyDetail = (data) => request.post('/api/ApplyDetail', data);  //获取审批详情

export const trainUesrsComplete = (data) => request.post('/api/trainUesrsComplete', data);  //用户自行完成培训

export const trainEditSupervise = (data) => request.post('/api/trainEditSupervise', data);  //编辑培训效果

export const trainSuperviseFile = (data) => request.post('/api/trainSuperviseFile', data);  //培训效果上传文件

export const trainSuperviseFileAdd = (data) => request.post('/api/trainSuperviseFileAdd', data);  //培训效果添加文件

export const trainSuperviseFileEdit = (data) => request.post('/api/trainSuperviseFileEdit', data);  //培训效果编辑文件

export const trainSuperviseFileDel = (data) => request.post('/api/trainSuperviseFileDel', data);  //培训效果删除文件

export const trainSuperviseComplete = (data) => request.post('/api/trainSuperviseComplete', data);  //培训效果审批完成